import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { DateInputsModule } from "@progress/kendo-angular-dateinputs";
import { DropDownsModule } from "@progress/kendo-angular-dropdowns";
import { ChartsModule } from "@progress/kendo-angular-charts";
import { ReportRoutingModule } from "./report-routing.module";
import { LobbyDetailViewComponent } from "./lobby-detail-view/lobby-detail-view.component";
import { ExcelModule, GridModule } from "@progress/kendo-angular-grid";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { FiltersComponent } from "./filters/filters.component";
import { ReportService } from "./shared/services/report.service";
import { WindowModule } from "@progress/kendo-angular-dialog";
import { LobbyEditorComponent } from "./lobby-editor/lobby-editor.component";
import { SaveAsComponent } from "./dialogs/save-as.component";
import { SaveComponent } from "./dialogs/save.component";
import { DeleteComponent } from "./dialogs/delete.component";
import { ShareComponent } from "./dialogs/share.component";
import { SharedModule } from "../shared/shared.module";

import { InputsModule } from "@progress/kendo-angular-inputs";
import { PopupModule } from "@progress/kendo-angular-popup";
import { DialogsModule } from "@progress/kendo-angular-dialog";
import { LayoutModule } from "@progress/kendo-angular-layout";
import { LobbyDataViewComponent } from "./lobby-data-view/lobby-data-view.component";

@NgModule({
  declarations: [
    LobbyDataViewComponent,
    LobbyDetailViewComponent,
    LobbyEditorComponent,
    FiltersComponent,
    SaveAsComponent,
    SaveComponent,
    DeleteComponent,
    ShareComponent,
  ],
  imports: [
    CommonModule,
    NgbModule,
    ChartsModule,
    DateInputsModule,
    GridModule,
    ReportRoutingModule,
    ExcelModule,
    FormsModule,
    ReactiveFormsModule,
    DropDownsModule,
    NgMultiSelectDropDownModule,
    WindowModule,
    SharedModule,
    InputsModule,
    PopupModule,
    DialogsModule,
    LayoutModule,
  ],
  providers: [ReportService],
})
export class ReportModule {}
